/* Glossmere buy panel: offer tiles + swatches -> real variant, price, sticky ATC, gallery (filtered by finish). */
(function () {
  function fmtMoney(cents, fmt) {
    var n = (cents / 100).toFixed(2);
    var withCommas = function (s) { var p = s.split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); return p.join('.'); };
    var out = String(fmt || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return withCommas(String(Math.round(cents / 100)));
      if (k === 'amount_with_comma_separator') return n.replace('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return String(Math.round(cents / 100));
      return withCommas(n);
    });
    return out.replace(/([.,])00(?!\d)/, '');
  }
  function addStyles() {
    if (document.getElementById('gm-units-style')) return;
    var s = document.createElement('style'); s.id = 'gm-units-style';
    s.textContent = '.gm-units{display:flex;align-items:center;gap:12px;border:1px solid rgba(0,0,0,.15);border-radius:14px;padding:12px 14px;margin:4px 0 16px}.gm-units .txt{font-size:14px;line-height:1.35}.gm-units .txt small{display:block;font-size:12px;opacity:.7}.gm-units .ctl{display:inline-flex;align-items:center;gap:12px;margin-left:auto}.gm-units button{width:34px;height:34px;border-radius:50%;border:1px solid rgba(0,0,0,.25);background:#fff;font-size:18px;line-height:1;cursor:pointer;color:inherit}.gm-units button:disabled{opacity:.35;cursor:not-allowed}.gm-units .n{min-width:18px;text-align:center;font-weight:600}.gm-each{display:block;font-size:12px;opacity:.7;font-weight:400}.gm-hide{display:none!important}';
    document.head.appendChild(s);
  }
  function init(root) {
    if (root.__gm) return; root.__gm = true;
    addStyles();
    var variants = JSON.parse(root.querySelector('[data-gm-variants]').textContent || '[]');
    var fmt = JSON.parse(root.querySelector('[data-gm-money]').textContent || '"${{amount}}"');
    var idInput = root.querySelector('[data-gm-id]');
    var priceEl = root.querySelector('[data-gm-price]');
    var atc = root.querySelector('[data-gm-atc]');
    var stickyBtn = root.querySelector('[data-gm-sticky-btn]');
    var stickyName = root.querySelector('[data-gm-sticky-name]');
    var current = variants.find(function (v) { return String(v.id) === idInput.value; }) || variants[0];
    var esc = function (s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; };

    function chosen() {
      var opts = current.options.slice();
      root.querySelectorAll('input[data-gm-opt]:checked').forEach(function (i) { opts[+i.dataset.gmOpt] = i.value; });
      return opts;
    }
    function find(opts) { return variants.find(function (v) { return v.options.every(function (o, k) { return o === opts[k]; }); }); }

    var group = root.querySelector('.swatches[aria-label="Heads"]');
    var unitsRadios = group ? Array.prototype.slice.call(group.querySelectorAll('input[data-gm-opt]')) : [];
    if (group && unitsRadios.length) {
      var lab = group.previousElementSibling;
      if (lab && lab.classList.contains('opt-label')) lab.style.display = 'none';
      group.style.display = 'none';
      var box = document.createElement('div'); box.className = 'gm-units';
      box.innerHTML = '<div class="txt"><b>Showerheads</b><small data-gm-units-hint></small></div><div class="ctl"><button type="button" data-gm-units-d="-1" aria-label="Fewer showerheads">&minus;</button><span class="n" data-gm-units-val>1</span><button type="button" data-gm-units-d="1" aria-label="Add a showerhead">+</button></div>';
      group.parentNode.insertBefore(box, group.nextSibling);
      box.querySelectorAll('[data-gm-units-d]').forEach(function (b) {
        b.addEventListener('click', function () {
          var idx = unitsRadios.findIndex(function (r) { return r.checked; });
          var next = Math.max(0, Math.min(unitsRadios.length - 1, idx + (+b.dataset.gmUnitsD)));
          if (next === idx) return;
          unitsRadios[next].checked = true;
          unitsRadios[next].dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }
    root.querySelectorAll('.bundle .p').forEach(function (p) { if (!p.querySelector('[data-gm-each]')) { var s = document.createElement('small'); s.className = 'gm-each'; s.setAttribute('data-gm-each', ''); p.appendChild(s); } });
    root.querySelectorAll('.atc-row .qty').forEach(function (q) { q.style.display = 'none'; });

    /* Gallery: tag each image by finish from its alt text ("matte black" / "chrome"), show only the chosen finish. */
    function mediaFinish(el) {
      var img = el.querySelector('img'); var a = ((img && img.alt) || '').toLowerCase();
      if (a.indexOf('matte black') > -1 || a.indexOf('black') > -1) return 'black';
      if (a.indexOf('chrome') > -1) return 'chrome';
      return '';
    }
    var gal = root.querySelector('[data-gm-gallery]');
    if (gal) {
      gal.querySelectorAll('.main-media > *').forEach(function (e) { e.dataset.gmFin = mediaFinish(e); });
      gal.querySelectorAll('[data-thumb]').forEach(function (b) { b.dataset.gmFin = mediaFinish(b); });
    }
    function applyFinish(fin) {
      if (!gal || !fin) return;
      var key = /black/i.test(fin) ? 'black' : (/chrome/i.test(fin) ? 'chrome' : '');
      if (!key) return;
      var any = gal.querySelector('.main-media > [data-gm-fin="' + key + '"]');
      if (!any) return;
      gal.querySelectorAll('.main-media > *, [data-thumb]').forEach(function (e) {
        var f = e.dataset.gmFin; e.classList.toggle('gm-hide', !!f && f !== key);
      });
      var act = gal.querySelector('.main-media > .is-active');
      if (!act || act.classList.contains('gm-hide')) {
        var first = gal.querySelector('.main-media > [data-gm-fin="' + key + '"]');
        if (first) setMedia(first.dataset.mediaId);
      }
    }

    function setMedia(id) {
      var g = root.querySelector('[data-gm-gallery]'); if (!g || !id) return;
      var slide = g.querySelector('.main-media [data-media-id="' + id + '"]'); if (!slide) return;
      g.querySelectorAll('.main-media > *').forEach(function (e) { e.classList.toggle('is-active', e === slide); });
      g.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.toggle('on', b.dataset.thumb === String(id)); });
    }

    function update(userChange) {
      var opts = chosen();
      var v = find(opts);
      root.querySelectorAll('.bundle').forEach(function (b) { var i = b.querySelector('input'); b.classList.toggle('on', i && i.checked); });
      root.querySelectorAll('.sw').forEach(function (b) { var i = b.querySelector('input'); b.classList.toggle('on', i && i.checked); });
      root.querySelectorAll('[data-gm-opt-label]').forEach(function (l) { l.textContent = opts[+l.dataset.gmOptLabel]; });
      // per-tile prices for the other chosen options
      root.querySelectorAll('.bundle input[data-gm-opt]').forEach(function (i) {
        var o = opts.slice(); o[+i.dataset.gmOpt] = i.value; var tv = find(o);
        var el = i.closest('.bundle').querySelector('[data-gm-tile-price]'); if (el && tv) el.textContent = fmtMoney(tv.price, fmt);
      });
      if (unitsRadios.length) {
        var ui = +unitsRadios[0].dataset.gmOpt, heads = parseInt(opts[ui], 10) || 1;
        var cur = unitsRadios.findIndex(function (r) { return r.checked; });
        root.querySelectorAll('[data-gm-units-val]').forEach(function (el) { el.textContent = heads; });
        root.querySelectorAll('[data-gm-units-d]').forEach(function (b) { var d = +b.dataset.gmUnitsD; b.disabled = (d < 0 && cur <= 0) || (d > 0 && cur >= unitsRadios.length - 1); });
        root.querySelectorAll('.bundle').forEach(function (b) { var i = b.querySelector('input'); var o = opts.slice(); o[+i.dataset.gmOpt] = i.value; var tv = find(o); var el = b.querySelector('[data-gm-each]'); if (el) el.textContent = (tv && heads > 1) ? fmtMoney(Math.round(tv.price / heads), fmt) + ' per head' : ''; });
        var hint = root.querySelector('[data-gm-units-hint]');
        if (hint) { var oo = opts.slice(); oo[ui] = unitsRadios[unitsRadios.length - 1].value; var t2 = find(oo); var h2 = parseInt(unitsRadios[unitsRadios.length - 1].value, 10) || 2; hint.textContent = (heads < h2 && t2) ? 'Add a second showerhead: ' + fmtMoney(Math.round(t2.price / h2), fmt) + ' per head' : 'Price per head is lower with two.'; }
      }
      if (!v) {
        if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; }
        if (stickyBtn) stickyBtn.disabled = true;
        return;
      }
      current = v; idInput.value = v.id;
      var tile = root.querySelector('.bundle input:checked');
      var price = fmtMoney(v.price, fmt);
      var html = esc(price);
      if (v.compare_at_price && v.compare_at_price > v.price) html += ' <s>' + esc(fmtMoney(v.compare_at_price, fmt)) + '</s>';
      if (tile && tile.dataset.val) html += ' <span class="val">' + esc(tile.dataset.val) + '</span>';
      if (tile && tile.dataset.save) html += ' <span class="save">' + esc(tile.dataset.save) + '</span>';
      if (priceEl) priceEl.innerHTML = html;
      if (atc) {
        atc.disabled = !v.available;
        atc.innerHTML = v.available ? esc(atc.dataset.label) + ' · <span class="js-atc-price">' + esc(price) + '</span>' : esc(atc.dataset.soldout);
      }
      if (stickyBtn) { stickyBtn.disabled = !v.available; var sp = stickyBtn.querySelector('.js-atc-price'); if (sp) sp.textContent = price; }
      if (stickyName) stickyName.textContent = (tile && tile.dataset.name) || v.title;
      var finGroup = root.querySelector('.swatches[aria-label="Finish"] input[data-gm-opt]');
      if (finGroup) applyFinish(opts[+finGroup.dataset.gmOpt]);
      if (v.featured_media) setMedia(v.featured_media.id);
      if (userChange) try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) {}
    }

    root.addEventListener('change', function (e) { if (e.target.matches('input[data-gm-opt]')) update(true); });
    root.querySelectorAll('.qty button').forEach(function (b) {
      b.addEventListener('click', function () { var q = root.querySelector('[data-gm-qty]'); q.value = Math.max(1, (parseInt(q.value, 10) || 1) + (+b.dataset.d)); });
    });
    root.querySelectorAll('[data-thumb]').forEach(function (b) { b.addEventListener('click', function () { setMedia(b.dataset.thumb); }); });

    var sticky = root.querySelector('[data-gm-sticky]'), row = root.querySelector('.atc-row');
    if (sticky && row && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { var e = en[0]; sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0); }).observe(row);
    }
    update();
  }
  function boot() { document.querySelectorAll('[data-gm-product]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
